import {useEffect, useState} from "react";
import {Form, UploadFile} from "antd";
import {ExternalLinkFormProps} from "../../../../types";
import Uploader from "../../../../../uploader/Uploader";
import * as BUCKETS from "../../../../../../enums/buckets";
import TextArea from "antd/es/input/TextArea";
import "./style.less"
import {getImageLink, showErrorNotification} from "../../../../../../helpers/mainHelpers";

const ExternalLinkForm = (props: ExternalLinkFormProps) => {
  const {externalLinksController} = props
  const {form, selectedExternalLink, submitButtonHandler} = externalLinksController
  const [uploadImages, setUploadImages] = useState<UploadFile[]>([])

  useEffect(() => {
    if (selectedExternalLink) {
      form.setFieldsValue(selectedExternalLink)
      const imageData = {
        uid: selectedExternalLink.imageId,
        name: "image",
        url: getImageLink({imageId: selectedExternalLink.imageId, bucketId: BUCKETS.MAIN}),
        response: {$id: selectedExternalLink.imageId}
      }
      setUploadImages([imageData])
    } else {
      setUploadImages([])
    }
  }, [selectedExternalLink])

  return <Form form={form} layout="vertical" className="externalLink_form" onFinish={async (formData) => {
    if (uploadImages?.length) {
      const imageId = uploadImages?.length ? uploadImages[0].response.$id : ""
      await submitButtonHandler({...formData, imageId})
    } else {
      showErrorNotification({
        message: "Додайте зображення!",
      })
    }

  }}>
    <Form.Item name="title" label="Заголовок" rules={[{required: true}]}>
      <TextArea/>
    </Form.Item>
    <Form.Item name="link" label="Посилання" rules={[{required: true}]}>
      <TextArea/>
    </Form.Item>
    <Form.Item label="Зображення">
      <Uploader maxCount={1} bucketId={BUCKETS.MAIN} files={uploadImages} setFiles={setUploadImages}/>
    </Form.Item>

  </Form>
}

export default ExternalLinkForm